"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScheduleTaskStatusEnum = exports.ScheduleTaskPriorityEnum = void 0;
/** Приоритет задания ScheduleTask.priority */
var ScheduleTaskPriorityEnum;
(function (ScheduleTaskPriorityEnum) {
  ScheduleTaskPriorityEnum[ScheduleTaskPriorityEnum["lowest"] = 0] = "lowest";
  ScheduleTaskPriorityEnum[ScheduleTaskPriorityEnum["low"] = 10] = "low";
  ScheduleTaskPriorityEnum[ScheduleTaskPriorityEnum["normal"] = 20] = "normal";
  ScheduleTaskPriorityEnum[ScheduleTaskPriorityEnum["high"] = 30] = "high";
  ScheduleTaskPriorityEnum[ScheduleTaskPriorityEnum["highest"] = 40] = "highest";
})(ScheduleTaskPriorityEnum = exports.ScheduleTaskPriorityEnum || (exports.ScheduleTaskPriorityEnum = {}));
/** Статус задания ScheduleTask.status */
var ScheduleTaskStatusEnum;
(function (ScheduleTaskStatusEnum) {
  /** ожидает */
  ScheduleTaskStatusEnum[ScheduleTaskStatusEnum["pending"] = 3] = "pending";
  /** исполняется */
  ScheduleTaskStatusEnum[ScheduleTaskStatusEnum["processing"] = 4] = "processing";
  /** завершена успешно */
  ScheduleTaskStatusEnum[ScheduleTaskStatusEnum["succeed"] = 5] = "succeed";
  /** отменена */
  ScheduleTaskStatusEnum[ScheduleTaskStatusEnum["canceled"] = 6] = "canceled";
  /** завершилась с ошибкой */
  ScheduleTaskStatusEnum[ScheduleTaskStatusEnum["failed"] = 7] = "failed";
  /** ожидает повторения */
  ScheduleTaskStatusEnum[ScheduleTaskStatusEnum["retrying"] = 8] = "retrying";
})(ScheduleTaskStatusEnum = exports.ScheduleTaskStatusEnum || (exports.ScheduleTaskStatusEnum = {}));
